import Vue from "vue"
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex)
export default new Vuex.Store({
  // 存储设置的变量
  state: {
    bgColor: "#F9F8F5",//底部的主题色
    navTopindex: 0,//头部索引
    language: "zh", // 语言
    loginFable: false,//登录弹框的显示/隐藏
    agreementFlag: false,// 是否同意协议
    logoutFable: false,//退出登录弹框
    userInfo: localStorage.getItem('hgnlPcUser'),//用户信息
  },
  // 修改state里面的值
  mutations: {
    // 更新语言
    changeLaunage(state, language) {
      state.language = language;
    },
    // 更新底部主题色
    updataColor(state, ploye) {
      state.bgColor = ploye
    },
    // 更新头部索引
    upDatetopindex(state, ploye) {
      state.navTopindex = ploye
    },
    // 更新用户信息
    updateMe(state, userInfo) {
      state.userInfo = userInfo;
      localStorage.setItem('bzysPcUser', JSON.stringify(userInfo));
    },
    // 更新登录弹框
    updataLogin(state, ploye) {
      state.loginFable = ploye
    },
    // 更新是否同意用户协议隐私政策
    updateAgreementFlag(state) {
      state.agreementFlag = !state.agreementFlag
    },
    // 更新退出登录弹框
    updataLogout(state, ploye) {
      state.logoutFable = ploye
    },
  },
  // 异步方法
  actions: {
  },
  plugins: [createPersistedState()]
})